<template>
    <pop
        customClass="calendar-select-pop"
        animation="bottomToUp"
        :allowClose="false"
        :closeOnClickModal="true"
    >
        <im-m-calendar
            :value="value"
            @confirm="confirm"
            @cancel="cancel"
        />
    </pop>
</template>

<script>
export default {
    name: 'CalendarPopup',
    emits: ['change'],
    props: {
        parentIns: { 
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        value() {
            if (this.parentIns.type === 'min') {
                return this.parentIns.minVal || Date.now();
            } else if (this.parentIns.type === 'max') {
                return this.parentIns.maxVal || Date.now();
            } else {
                return Date.now();
            }
        }
    },
    methods: {
        confirm(val) {
            this.$emit('change', val);
            this.destroy();
        },
        cancel() {
            this.destroy();
        }
    }
};
</script>

<style lang="scss">
.calendar-select-pop {
    background: #fff;
}
</style>
